import { FC, memo, useMemo } from 'react'

type InterestButtonProps = {
  label: string
  value: string
  isSelected?: boolean
  className?: string
  onClick: (interestValue: string) => void
}

const InterestButtonComponent: FC<InterestButtonProps> = ({
  className = '',
  label,
  value,
  isSelected = false,
  onClick,
}) => {
  const buttonStyle = useMemo(() => {
    return isSelected
      ? 'bg-white text-cool-gray-900'
      : 'border-cool-gray-700 text-white'
  }, [isSelected])

  return (
    <div
      className={`inline-block rounded-full border-[1px] px-6 py-1 text-sm font-bold cursor-pointer ${buttonStyle} ${className}`}
      onClick={() => onClick(value)}
    >
      <span>{label}</span>
    </div>
  )
}

export const InterestButton = memo(InterestButtonComponent)
